import { Timestamp } from "../../../google/protobuf/timestamp.js";
import { ButtonData } from "./plugin_button.js";
import { CodeBlockData } from "./node_code_block.js";
import { DividerData } from "./plugin_divider.js";
import { FileData } from "./plugin_file.js";
import { GalleryData } from "./plugin_gallery.js";
import { GIFData } from "./plugin_gif.js";
import { HeadingData } from "./node_heading.js";
import { HTMLData } from "./plugin_html.js";
import { ImageData } from "./plugin_image.js";
import { LinkPreviewData } from "./plugin_link_preview.js";
import { MapData } from "./plugin_map.js";
import { ParagraphData } from "./node_paragraph.js";
import { PollData } from "./plugin_poll.js";
import { AppEmbedData } from "./plugin_app_embed.js";
import { VideoData } from "./plugin_video.js";
import { EmbedData } from "./plugin_embed.js";
import { CollapsibleListData } from "./plugin_collapsible_list.js";
import { TableData } from "./plugin_table.js";
import { TableCellData } from "./plugin_table_cell.js";
import { Struct } from "./struct.js";
import { AudioData } from "./plugin_audio.js";
import { OrderedListData, BulletedListData } from "./node_list.js";
import { BlockquoteData } from "./node_blockquote.js";
import { CaptionData } from "./node_caption.js";
import { LayoutCellData } from "./node_layout_cell.js";
import { AnchorData } from "./decoration_anchor.js";
import { ColorData } from "./decoration_color.js";
import { LinkData } from "./decoration_link.js";
import { MentionData } from "./decoration_mention.js";
import { FontSizeData } from "./decoration_fontsize.js";
import { SpoilerData } from "./decoration_spoiler.js";
import { Node_Type, Decoration_Type } from "./rich_content.enums.js";
function node_TypeFromJSON(object) {
  switch (object) {
    case 0:
    case "PARAGRAPH":
      return Node_Type.PARAGRAPH;
    case 1:
    case "TEXT":
      return Node_Type.TEXT;
    case 2:
    case "HEADING":
      return Node_Type.HEADING;
    case 3:
    case "BULLETED_LIST":
      return Node_Type.BULLETED_LIST;
    case 4:
    case "ORDERED_LIST":
      return Node_Type.ORDERED_LIST;
    case 5:
    case "LIST_ITEM":
      return Node_Type.LIST_ITEM;
    case 6:
    case "BLOCKQUOTE":
      return Node_Type.BLOCKQUOTE;
    case 7:
    case "CODE_BLOCK":
      return Node_Type.CODE_BLOCK;
    case 8:
    case "VIDEO":
      return Node_Type.VIDEO;
    case 9:
    case "DIVIDER":
      return Node_Type.DIVIDER;
    case 10:
    case "FILE":
      return Node_Type.FILE;
    case 11:
    case "GALLERY":
      return Node_Type.GALLERY;
    case 12:
    case "GIF":
      return Node_Type.GIF;
    case 13:
    case "HTML":
      return Node_Type.HTML;
    case 14:
    case "IMAGE":
      return Node_Type.IMAGE;
    case 15:
    case "LINK_PREVIEW":
      return Node_Type.LINK_PREVIEW;
    case 16:
    case "MAP":
      return Node_Type.MAP;
    case 17:
    case "POLL":
      return Node_Type.POLL;
    case 18:
    case "APP_EMBED":
      return Node_Type.APP_EMBED;
    case 19:
    case "BUTTON":
      return Node_Type.BUTTON;
    case 20:
    case "COLLAPSIBLE_LIST":
      return Node_Type.COLLAPSIBLE_LIST;
    case 21:
    case "TABLE":
      return Node_Type.TABLE;
    case 22:
    case "EMBED":
      return Node_Type.EMBED;
    case 23:
    case "COLLAPSIBLE_ITEM":
      return Node_Type.COLLAPSIBLE_ITEM;
    case 24:
    case "COLLAPSIBLE_ITEM_TITLE":
      return Node_Type.COLLAPSIBLE_ITEM_TITLE;
    case 25:
    case "COLLAPSIBLE_ITEM_BODY":
      return Node_Type.COLLAPSIBLE_ITEM_BODY;
    case 26:
    case "TABLE_CELL":
      return Node_Type.TABLE_CELL;
    case 27:
    case "TABLE_ROW":
      return Node_Type.TABLE_ROW;
    case 28:
    case "EXTERNAL":
      return Node_Type.EXTERNAL;
    case 29:
    case "AUDIO":
      return Node_Type.AUDIO;
    case 30:
    case "CAPTION":
      return Node_Type.CAPTION;
    case 31:
    case "LAYOUT":
      return Node_Type.LAYOUT;
    case 32:
    case "LAYOUT_CELL":
      return Node_Type.LAYOUT_CELL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Node_Type.UNRECOGNIZED;
  }
}
function node_TypeToJSON(object) {
  switch (object) {
    case Node_Type.PARAGRAPH:
      return "PARAGRAPH";
    case Node_Type.TEXT:
      return "TEXT";
    case Node_Type.HEADING:
      return "HEADING";
    case Node_Type.BULLETED_LIST:
      return "BULLETED_LIST";
    case Node_Type.ORDERED_LIST:
      return "ORDERED_LIST";
    case Node_Type.LIST_ITEM:
      return "LIST_ITEM";
    case Node_Type.BLOCKQUOTE:
      return "BLOCKQUOTE";
    case Node_Type.CODE_BLOCK:
      return "CODE_BLOCK";
    case Node_Type.VIDEO:
      return "VIDEO";
    case Node_Type.DIVIDER:
      return "DIVIDER";
    case Node_Type.FILE:
      return "FILE";
    case Node_Type.GALLERY:
      return "GALLERY";
    case Node_Type.GIF:
      return "GIF";
    case Node_Type.HTML:
      return "HTML";
    case Node_Type.IMAGE:
      return "IMAGE";
    case Node_Type.LINK_PREVIEW:
      return "LINK_PREVIEW";
    case Node_Type.MAP:
      return "MAP";
    case Node_Type.POLL:
      return "POLL";
    case Node_Type.APP_EMBED:
      return "APP_EMBED";
    case Node_Type.BUTTON:
      return "BUTTON";
    case Node_Type.COLLAPSIBLE_LIST:
      return "COLLAPSIBLE_LIST";
    case Node_Type.TABLE:
      return "TABLE";
    case Node_Type.EMBED:
      return "EMBED";
    case Node_Type.COLLAPSIBLE_ITEM:
      return "COLLAPSIBLE_ITEM";
    case Node_Type.COLLAPSIBLE_ITEM_TITLE:
      return "COLLAPSIBLE_ITEM_TITLE";
    case Node_Type.COLLAPSIBLE_ITEM_BODY:
      return "COLLAPSIBLE_ITEM_BODY";
    case Node_Type.TABLE_CELL:
      return "TABLE_CELL";
    case Node_Type.TABLE_ROW:
      return "TABLE_ROW";
    case Node_Type.EXTERNAL:
      return "EXTERNAL";
    case Node_Type.AUDIO:
      return "AUDIO";
    case Node_Type.CAPTION:
      return "CAPTION";
    case Node_Type.LAYOUT:
      return "LAYOUT";
    case Node_Type.LAYOUT_CELL:
      return "LAYOUT_CELL";
    default:
      return "UNKNOWN";
  }
}
function decoration_TypeFromJSON(object) {
  switch (object) {
    case 0:
    case "BOLD":
      return Decoration_Type.BOLD;
    case 1:
    case "ITALIC":
      return Decoration_Type.ITALIC;
    case 2:
    case "UNDERLINE":
      return Decoration_Type.UNDERLINE;
    case 3:
    case "SPOILER":
      return Decoration_Type.SPOILER;
    case 4:
    case "ANCHOR":
      return Decoration_Type.ANCHOR;
    case 5:
    case "MENTION":
      return Decoration_Type.MENTION;
    case 6:
    case "LINK":
      return Decoration_Type.LINK;
    case 7:
    case "COLOR":
      return Decoration_Type.COLOR;
    case 8:
    case "FONT_SIZE":
      return Decoration_Type.FONT_SIZE;
    case 9:
    case "EXTERNAL":
      return Decoration_Type.EXTERNAL;
    case 10:
    case "STRIKETHROUGH":
      return Decoration_Type.STRIKETHROUGH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Decoration_Type.UNRECOGNIZED;
  }
}
function decoration_TypeToJSON(object) {
  switch (object) {
    case Decoration_Type.BOLD:
      return "BOLD";
    case Decoration_Type.ITALIC:
      return "ITALIC";
    case Decoration_Type.UNDERLINE:
      return "UNDERLINE";
    case Decoration_Type.SPOILER:
      return "SPOILER";
    case Decoration_Type.ANCHOR:
      return "ANCHOR";
    case Decoration_Type.MENTION:
      return "MENTION";
    case Decoration_Type.LINK:
      return "LINK";
    case Decoration_Type.COLOR:
      return "COLOR";
    case Decoration_Type.FONT_SIZE:
      return "FONT_SIZE";
    case Decoration_Type.EXTERNAL:
      return "EXTERNAL";
    case Decoration_Type.STRIKETHROUGH:
      return "STRIKETHROUGH";
    default:
      return "UNKNOWN";
  }
}
const baseRichContent = {};
const RichContent = {
  fromJSON(object) {
    const message = { ...baseRichContent };
    message.nodes = (object.nodes ?? []).map((e) => Node.fromJSON(e));
    message.metadata = object.metadata !== void 0 && object.metadata !== null ? Metadata.fromJSON(object.metadata) : void 0;
    message.documentStyle = object.documentStyle !== void 0 && object.documentStyle !== null ? DocumentStyle.fromJSON(object.documentStyle) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    if (message.nodes) {
      obj.nodes = message.nodes.map((e) => e ? Node.toJSON(e) : void 0);
    } else {
      obj.nodes = [];
    }
    message.metadata !== void 0 && (obj.metadata = message.metadata ? Metadata.toJSON(message.metadata) : void 0);
    message.documentStyle !== void 0 && (obj.documentStyle = message.documentStyle ? DocumentStyle.toJSON(message.documentStyle) : void 0);
    return obj;
  }
};
const baseNode = { type: Node_Type.PARAGRAPH, id: "" };
const Node = {
  fromJSON(object) {
    const message = { ...baseNode };
    message.type = object.type !== void 0 && object.type !== null ? node_TypeFromJSON(object.type) : Node_Type.PARAGRAPH;
    message.id = object.id !== void 0 && object.id !== null ? String(object.id) : "";
    message.nodes = (object.nodes ?? []).map((e) => Node.fromJSON(e));
    message.style = object.style !== void 0 && object.style !== null ? NodeStyle.fromJSON(object.style) : void 0;
    message.buttonData = object.buttonData !== void 0 && object.buttonData !== null ? ButtonData.fromJSON(object.buttonData) : void 0;
    message.codeBlockData = object.codeBlockData !== void 0 && object.codeBlockData !== null ? CodeBlockData.fromJSON(object.codeBlockData) : void 0;
    message.dividerData = object.dividerData !== void 0 && object.dividerData !== null ? DividerData.fromJSON(object.dividerData) : void 0;
    message.fileData = object.fileData !== void 0 && object.fileData !== null ? FileData.fromJSON(object.fileData) : void 0;
    message.galleryData = object.galleryData !== void 0 && object.galleryData !== null ? GalleryData.fromJSON(object.galleryData) : void 0;
    message.gifData = object.gifData !== void 0 && object.gifData !== null ? GIFData.fromJSON(object.gifData) : void 0;
    message.headingData = object.headingData !== void 0 && object.headingData !== null ? HeadingData.fromJSON(object.headingData) : void 0;
    message.htmlData = object.htmlData !== void 0 && object.htmlData !== null ? HTMLData.fromJSON(object.htmlData) : void 0;
    message.imageData = object.imageData !== void 0 && object.imageData !== null ? ImageData.fromJSON(object.imageData) : void 0;
    message.linkPreviewData = object.linkPreviewData !== void 0 && object.linkPreviewData !== null ? LinkPreviewData.fromJSON(object.linkPreviewData) : void 0;
    message.mapData = object.mapData !== void 0 && object.mapData !== null ? MapData.fromJSON(object.mapData) : void 0;
    message.paragraphData = object.paragraphData !== void 0 && object.paragraphData !== null ? ParagraphData.fromJSON(object.paragraphData) : void 0;
    message.pollData = object.pollData !== void 0 && object.pollData !== null ? PollData.fromJSON(object.pollData) : void 0;
    message.textData = object.textData !== void 0 && object.textData !== null ? TextData.fromJSON(object.textData) : void 0;
    message.appEmbedData = object.appEmbedData !== void 0 && object.appEmbedData !== null ? AppEmbedData.fromJSON(object.appEmbedData) : void 0;
    message.videoData = object.videoData !== void 0 && object.videoData !== null ? VideoData.fromJSON(object.videoData) : void 0;
    message.embedData = object.embedData !== void 0 && object.embedData !== null ? EmbedData.fromJSON(object.embedData) : void 0;
    message.collapsibleListData = object.collapsibleListData !== void 0 && object.collapsibleListData !== null ? CollapsibleListData.fromJSON(object.collapsibleListData) : void 0;
    message.tableData = object.tableData !== void 0 && object.tableData !== null ? TableData.fromJSON(object.tableData) : void 0;
    message.tableCellData = object.tableCellData !== void 0 && object.tableCellData !== null ? TableCellData.fromJSON(object.tableCellData) : void 0;
    message.externalData = object.externalData !== void 0 && object.externalData !== null ? Struct.fromJSON(object.externalData) : void 0;
    message.audioData = object.audioData !== void 0 && object.audioData !== null ? AudioData.fromJSON(object.audioData) : void 0;
    message.orderedListData = object.orderedListData !== void 0 && object.orderedListData !== null ? OrderedListData.fromJSON(object.orderedListData) : void 0;
    message.bulletedListData = object.bulletedListData !== void 0 && object.bulletedListData !== null ? BulletedListData.fromJSON(object.bulletedListData) : void 0;
    message.blockquoteData = object.blockquoteData !== void 0 && object.blockquoteData !== null ? BlockquoteData.fromJSON(object.blockquoteData) : void 0;
    message.captionData = object.captionData !== void 0 && object.captionData !== null ? CaptionData.fromJSON(object.captionData) : void 0;
    message.layoutCellData = object.layoutCellData !== void 0 && object.layoutCellData !== null ? LayoutCellData.fromJSON(object.layoutCellData) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.type !== void 0 && (obj.type = node_TypeToJSON(message.type));
    message.id !== void 0 && (obj.id = message.id);
    if (message.nodes) {
      obj.nodes = message.nodes.map((e) => e ? Node.toJSON(e) : void 0);
    } else {
      obj.nodes = [];
    }
    message.style !== void 0 && (obj.style = message.style ? NodeStyle.toJSON(message.style) : void 0);
    message.buttonData !== void 0 && (obj.buttonData = message.buttonData ? ButtonData.toJSON(message.buttonData) : void 0);
    message.codeBlockData !== void 0 && (obj.codeBlockData = message.codeBlockData ? CodeBlockData.toJSON(message.codeBlockData) : void 0);
    message.dividerData !== void 0 && (obj.dividerData = message.dividerData ? DividerData.toJSON(message.dividerData) : void 0);
    message.fileData !== void 0 && (obj.fileData = message.fileData ? FileData.toJSON(message.fileData) : void 0);
    message.galleryData !== void 0 && (obj.galleryData = message.galleryData ? GalleryData.toJSON(message.galleryData) : void 0);
    message.gifData !== void 0 && (obj.gifData = message.gifData ? GIFData.toJSON(message.gifData) : void 0);
    message.headingData !== void 0 && (obj.headingData = message.headingData ? HeadingData.toJSON(message.headingData) : void 0);
    message.htmlData !== void 0 && (obj.htmlData = message.htmlData ? HTMLData.toJSON(message.htmlData) : void 0);
    message.imageData !== void 0 && (obj.imageData = message.imageData ? ImageData.toJSON(message.imageData) : void 0);
    message.linkPreviewData !== void 0 && (obj.linkPreviewData = message.linkPreviewData ? LinkPreviewData.toJSON(message.linkPreviewData) : void 0);
    message.mapData !== void 0 && (obj.mapData = message.mapData ? MapData.toJSON(message.mapData) : void 0);
    message.paragraphData !== void 0 && (obj.paragraphData = message.paragraphData ? ParagraphData.toJSON(message.paragraphData) : void 0);
    message.pollData !== void 0 && (obj.pollData = message.pollData ? PollData.toJSON(message.pollData) : void 0);
    message.textData !== void 0 && (obj.textData = message.textData ? TextData.toJSON(message.textData) : void 0);
    message.appEmbedData !== void 0 && (obj.appEmbedData = message.appEmbedData ? AppEmbedData.toJSON(message.appEmbedData) : void 0);
    message.videoData !== void 0 && (obj.videoData = message.videoData ? VideoData.toJSON(message.videoData) : void 0);
    message.embedData !== void 0 && (obj.embedData = message.embedData ? EmbedData.toJSON(message.embedData) : void 0);
    message.collapsibleListData !== void 0 && (obj.collapsibleListData = message.collapsibleListData ? CollapsibleListData.toJSON(message.collapsibleListData) : void 0);
    message.tableData !== void 0 && (obj.tableData = message.tableData ? TableData.toJSON(message.tableData) : void 0);
    message.tableCellData !== void 0 && (obj.tableCellData = message.tableCellData ? TableCellData.toJSON(message.tableCellData) : void 0);
    message.externalData !== void 0 && (obj.externalData = message.externalData ? Struct.toJSON(message.externalData) : void 0);
    message.audioData !== void 0 && (obj.audioData = message.audioData ? AudioData.toJSON(message.audioData) : void 0);
    message.orderedListData !== void 0 && (obj.orderedListData = message.orderedListData ? OrderedListData.toJSON(message.orderedListData) : void 0);
    message.bulletedListData !== void 0 && (obj.bulletedListData = message.bulletedListData ? BulletedListData.toJSON(message.bulletedListData) : void 0);
    message.blockquoteData !== void 0 && (obj.blockquoteData = message.blockquoteData ? BlockquoteData.toJSON(message.blockquoteData) : void 0);
    message.captionData !== void 0 && (obj.captionData = message.captionData ? CaptionData.toJSON(message.captionData) : void 0);
    message.layoutCellData !== void 0 && (obj.layoutCellData = message.layoutCellData ? LayoutCellData.toJSON(message.layoutCellData) : void 0);
    return obj;
  }
};
const baseNodeStyle = {};
const NodeStyle = {
  fromJSON(object) {
    const message = { ...baseNodeStyle };
    message.paddingTop = object.paddingTop !== void 0 && object.paddingTop !== null ? String(object.paddingTop) : void 0;
    message.paddingBottom = object.paddingBottom !== void 0 && object.paddingBottom !== null ? String(object.paddingBottom) : void 0;
    message.backgroundColor = object.backgroundColor !== void 0 && object.backgroundColor !== null ? String(object.backgroundColor) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.paddingTop !== void 0 && (obj.paddingTop = message.paddingTop);
    message.paddingBottom !== void 0 && (obj.paddingBottom = message.paddingBottom);
    message.backgroundColor !== void 0 && (obj.backgroundColor = message.backgroundColor);
    return obj;
  }
};
const baseTextData = { text: "" };
const TextData = {
  fromJSON(object) {
    const message = { ...baseTextData };
    message.text = object.text !== void 0 && object.text !== null ? String(object.text) : "";
    message.decorations = (object.decorations ?? []).map((e) => Decoration.fromJSON(e));
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.text !== void 0 && (obj.text = message.text);
    if (message.decorations) {
      obj.decorations = message.decorations.map((e) => e ? Decoration.toJSON(e) : void 0);
    } else {
      obj.decorations = [];
    }
    return obj;
  }
};
const baseDecoration = { type: Decoration_Type.BOLD };
const Decoration = {
  fromJSON(object) {
    const message = { ...baseDecoration };
    message.type = object.type !== void 0 && object.type !== null ? decoration_TypeFromJSON(object.type) : Decoration_Type.BOLD;
    message.anchorData = object.anchorData !== void 0 && object.anchorData !== null ? AnchorData.fromJSON(object.anchorData) : void 0;
    message.colorData = object.colorData !== void 0 && object.colorData !== null ? ColorData.fromJSON(object.colorData) : void 0;
    message.linkData = object.linkData !== void 0 && object.linkData !== null ? LinkData.fromJSON(object.linkData) : void 0;
    message.mentionData = object.mentionData !== void 0 && object.mentionData !== null ? MentionData.fromJSON(object.mentionData) : void 0;
    message.fontSizeData = object.fontSizeData !== void 0 && object.fontSizeData !== null ? FontSizeData.fromJSON(object.fontSizeData) : void 0;
    message.fontWeightValue = object.fontWeightValue !== void 0 && object.fontWeightValue !== null ? Number(object.fontWeightValue) : void 0;
    message.italicData = object.italicData !== void 0 && object.italicData !== null ? Boolean(object.italicData) : void 0;
    message.underlineData = object.underlineData !== void 0 && object.underlineData !== null ? Boolean(object.underlineData) : void 0;
    message.spoilerData = object.spoilerData !== void 0 && object.spoilerData !== null ? SpoilerData.fromJSON(object.spoilerData) : void 0;
    message.strikethroughData = object.strikethroughData !== void 0 && object.strikethroughData !== null ? Boolean(object.strikethroughData) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.type !== void 0 && (obj.type = decoration_TypeToJSON(message.type));
    message.anchorData !== void 0 && (obj.anchorData = message.anchorData ? AnchorData.toJSON(message.anchorData) : void 0);
    message.colorData !== void 0 && (obj.colorData = message.colorData ? ColorData.toJSON(message.colorData) : void 0);
    message.linkData !== void 0 && (obj.linkData = message.linkData ? LinkData.toJSON(message.linkData) : void 0);
    message.mentionData !== void 0 && (obj.mentionData = message.mentionData ? MentionData.toJSON(message.mentionData) : void 0);
    message.fontSizeData !== void 0 && (obj.fontSizeData = message.fontSizeData ? FontSizeData.toJSON(message.fontSizeData) : void 0);
    message.fontWeightValue !== void 0 && (obj.fontWeightValue = message.fontWeightValue);
    message.italicData !== void 0 && (obj.italicData = message.italicData);
    message.underlineData !== void 0 && (obj.underlineData = message.underlineData);
    message.spoilerData !== void 0 && (obj.spoilerData = message.spoilerData ? SpoilerData.toJSON(message.spoilerData) : void 0);
    message.strikethroughData !== void 0 && (obj.strikethroughData = message.strikethroughData);
    return obj;
  }
};
const baseMetadata = { version: 0 };
const Metadata = {
  fromJSON(object) {
    const message = { ...baseMetadata };
    message.version = object.version !== void 0 && object.version !== null ? Number(object.version) : 0;
    message.createdTimestamp = object.createdTimestamp !== void 0 && object.createdTimestamp !== null ? fromJsonTimestamp(object.createdTimestamp) : void 0;
    message.updatedTimestamp = object.updatedTimestamp !== void 0 && object.updatedTimestamp !== null ? fromJsonTimestamp(object.updatedTimestamp) : void 0;
    message.id = object.id !== void 0 && object.id !== null ? String(object.id) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.version !== void 0 && (obj.version = Math.round(message.version));
    message.createdTimestamp !== void 0 && (obj.createdTimestamp = message.createdTimestamp.toISOString());
    message.updatedTimestamp !== void 0 && (obj.updatedTimestamp = message.updatedTimestamp.toISOString());
    message.id !== void 0 && (obj.id = message.id);
    return obj;
  }
};
const baseTextNodeStyle = {};
const TextNodeStyle = {
  fromJSON(object) {
    const message = { ...baseTextNodeStyle };
    message.decorations = (object.decorations ?? []).map((e) => Decoration.fromJSON(e));
    message.nodeStyle = object.nodeStyle !== void 0 && object.nodeStyle !== null ? NodeStyle.fromJSON(object.nodeStyle) : void 0;
    message.lineHeight = object.lineHeight !== void 0 && object.lineHeight !== null ? String(object.lineHeight) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    if (message.decorations) {
      obj.decorations = message.decorations.map((e) => e ? Decoration.toJSON(e) : void 0);
    } else {
      obj.decorations = [];
    }
    message.nodeStyle !== void 0 && (obj.nodeStyle = message.nodeStyle ? NodeStyle.toJSON(message.nodeStyle) : void 0);
    message.lineHeight !== void 0 && (obj.lineHeight = message.lineHeight);
    return obj;
  }
};
const baseDocumentStyle = {};
const DocumentStyle = {
  fromJSON(object) {
    const message = { ...baseDocumentStyle };
    message.headerOne = object.headerOne !== void 0 && object.headerOne !== null ? TextNodeStyle.fromJSON(object.headerOne) : void 0;
    message.headerTwo = object.headerTwo !== void 0 && object.headerTwo !== null ? TextNodeStyle.fromJSON(object.headerTwo) : void 0;
    message.headerThree = object.headerThree !== void 0 && object.headerThree !== null ? TextNodeStyle.fromJSON(object.headerThree) : void 0;
    message.headerFour = object.headerFour !== void 0 && object.headerFour !== null ? TextNodeStyle.fromJSON(object.headerFour) : void 0;
    message.headerFive = object.headerFive !== void 0 && object.headerFive !== null ? TextNodeStyle.fromJSON(object.headerFive) : void 0;
    message.headerSix = object.headerSix !== void 0 && object.headerSix !== null ? TextNodeStyle.fromJSON(object.headerSix) : void 0;
    message.paragraph = object.paragraph !== void 0 && object.paragraph !== null ? TextNodeStyle.fromJSON(object.paragraph) : void 0;
    message.blockquote = object.blockquote !== void 0 && object.blockquote !== null ? TextNodeStyle.fromJSON(object.blockquote) : void 0;
    message.codeBlock = object.codeBlock !== void 0 && object.codeBlock !== null ? TextNodeStyle.fromJSON(object.codeBlock) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.headerOne !== void 0 && (obj.headerOne = message.headerOne ? TextNodeStyle.toJSON(message.headerOne) : void 0);
    message.headerTwo !== void 0 && (obj.headerTwo = message.headerTwo ? TextNodeStyle.toJSON(message.headerTwo) : void 0);
    message.headerThree !== void 0 && (obj.headerThree = message.headerThree ? TextNodeStyle.toJSON(message.headerThree) : void 0);
    message.headerFour !== void 0 && (obj.headerFour = message.headerFour ? TextNodeStyle.toJSON(message.headerFour) : void 0);
    message.headerFive !== void 0 && (obj.headerFive = message.headerFive ? TextNodeStyle.toJSON(message.headerFive) : void 0);
    message.headerSix !== void 0 && (obj.headerSix = message.headerSix ? TextNodeStyle.toJSON(message.headerSix) : void 0);
    message.paragraph !== void 0 && (obj.paragraph = message.paragraph ? TextNodeStyle.toJSON(message.paragraph) : void 0);
    message.blockquote !== void 0 && (obj.blockquote = message.blockquote ? TextNodeStyle.toJSON(message.blockquote) : void 0);
    message.codeBlock !== void 0 && (obj.codeBlock = message.codeBlock ? TextNodeStyle.toJSON(message.codeBlock) : void 0);
    return obj;
  }
};
function fromTimestamp(t) {
  let millis = Number(t.seconds) * 1e3;
  millis += t.nanos / 1e6;
  return new Date(millis);
}
function fromJsonTimestamp(o) {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}
export {
  Decoration,
  DocumentStyle,
  Metadata,
  Node,
  NodeStyle,
  RichContent,
  TextData,
  TextNodeStyle,
  decoration_TypeFromJSON,
  decoration_TypeToJSON,
  node_TypeFromJSON,
  node_TypeToJSON
};
//# sourceMappingURL=rich_content.js.map
